import Marquee from "react-fast-marquee";

const WORDS = ["Fotografia", "Video", "Editorial", "Drone", "Sport", "Ritratti", "Eventi", "Montaggio"];

export default function EditorialMarquee() {
    return (
        <section
            className="border-y border-white/10 py-6 md:py-12 bg-ink-950 overflow-hidden"
            data-testid="marquee-section"
            aria-label="Servizi in evidenza"
        >
            <Marquee gradient={false} speed={38} pauseOnHover={false}>
                {[...WORDS, ...WORDS].map((w, i) => (
                    <span
                        key={i}
                        className={`font-display uppercase mx-5 md:mx-14 ${i % 2 === 0 ? "text-bone-50" : "stroke-text"}`}
                        style={{ fontSize: "clamp(2rem, 10vw, 10rem)", lineHeight: 1, letterSpacing: "-0.03em" }}
                    >
                        {w}<span className="text-flash">.</span>
                    </span>
                ))}
            </Marquee>
        </section>
    );
}
